import Alpine from "alpinejs";
import './styles.pcss';

document.addEventListener('alpine:init', () => {
    Alpine.data('expressFormLanding', () => {
        return {
            isFirstStep : true,
            currentStepIndex: 0,
            init() {
                const container = document.querySelector('.heroLanding')
                const nextBtn = container?.querySelector('.expressBtnNext');
                const prevBtn = container?.querySelector('.expressBtnPrev');
                const linkTo = container?.querySelector('.js-button-landing');
                const buttonLinkTo = container?.querySelector('.js-container-scrolling');
                const anchor : any = container?.querySelector('.expressFormLegals');
            
                if (anchor) {
                    linkTo?.addEventListener('click', () => {
                        const anchorTop = anchor.getBoundingClientRect().top
                        buttonLinkTo?.scrollTo({ top: anchorTop, left : 0, behavior: 'smooth'})
                    })
                }
               

                const handleContent = () => {
                    if (this.currentStepIndex >= 1 ) {
                        this.isFirstStep = false
                    } else {
                        this.isFirstStep = true
                    }
                }
                nextBtn?.addEventListener('click', () => {
                    if (!nextBtn?.classList.contains('opacity-70')) {
                        this.currentStepIndex = this.currentStepIndex + 1
                        handleContent()
                    }
                })
                prevBtn?.addEventListener('click', () => {
                    this.currentStepIndex = this.currentStepIndex - 1
                    handleContent()
                })

                
            },
        };
    });
});

